module.exports = __webpack_public_path__ + "live-tip-cross-e684198f.png";